import React, { useEffect } from "react";
//MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

//OTHER
import ContentWithIcon from "../../ContentWithFilterIcon/ContentWithIcon";
import { useNavigate } from "react-router-dom";
import AllotedJobsCard from "../../../Cards/JobSeeker/AllotedJobsCard";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSelectedCandidates,
  getAllotedJobsData,
  setAllotedJobs,
} from "../../../../redux/Freelancer/allotedJobsSlice";
import NoJobsFound from "../../../NotFound/NoJobsFound";
import moment from "moment";
import { setIsLoading } from "../../../../redux/globalSlice";
import GlobalLoader from "../../../Loader/GlobalLoader";

const AllJobs = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading } = useSelector(state => state.app);
  const allotedJobs = useSelector(state => state.allotedJobs.allotedJobs)
  useEffect(() => {
    dispatch(setIsLoading(true));
    dispatch(getAllotedJobsData())
      .then((res) => {
        if (res.type === "getAllotedJobsData/fulfilled") {
          dispatch(setIsLoading(false));
          dispatch(setAllotedJobs(res.payload.data));
        } else if (res.type === "getAllotedJobsData/rejected") {
          dispatch(setIsLoading(false));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <Box className="freelancer-jobs-container">
      <ContentWithIcon
        data={props}
        content={`${allotedJobs?.length} Jobs Alloted`}
        className="oh-content-icon"
      />
      {
        isLoading ? <GlobalLoader minHeight="300px" /> : (
          <Grid container spacing={1}>
            {allotedJobs?.length > 0 ? (
              allotedJobs.map((elem) => {
                return (
                  <Grid className="cards-freelancer-responsive-1400" item xs={12} md={6} lg={4}>
                    <AllotedJobsCard
                      cardType="allJobs"
                      footerText={true}
                      timestamp={moment(elem?.attributes?.created_at).fromNow()}
                      imgShow={false}
                      data={elem?.attributes}
                      title="Add Candidates"
                      handleNavigate={() => {
                        dispatch(clearSelectedCandidates());
                        navigate(`/allotted-jobs/job-details/${elem?.id}`);
                      }}
                    />
                  </Grid>
                );
              })
            ) : (
              <NoJobsFound height={"250px"} value={"No alloted jobs yet"} />
            )}
          </Grid>
        )
      }
    </Box>
  );
};

export default AllJobs;
